import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LocationFormFactory } from '../../mappers/location-form.factory';
import { OnlineBookingUrlDto } from '../../dtos/online-booking-url.dto';
import { LanguagePipe } from '../../pipes/language.pipe';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-manage-link',
  imports: [ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatCardModule, LanguagePipe, TranslocoPipe],
  templateUrl: './manage-link.dialog.html',
  styleUrl: './manage-link.dialog.scss'
})
export class ManageLinkDialog implements OnInit {
  error?: string;
  onlineBookingUrlForm!: FormGroup;

  constructor(private dialogRef: MatDialogRef<ManageLinkDialog>, private translocoService: TranslocoService,@Inject(MAT_DIALOG_DATA) public onlineBookingUrlDto: OnlineBookingUrlDto, private fb: FormBuilder) {
  }

  get name() {
    return this.onlineBookingUrlForm.get('name') as FormArray;
  }

  ngOnInit(): void {
    if (!this.onlineBookingUrlDto) {
      this.onlineBookingUrlDto = {
        name: [
          { language: 'en', value: '' },
          { language: 'de', value: '' },
          { language: 'fr', value: '' },
          { language: 'it', value: '' }
        ],
        link: ''
      };
    }

    this.onlineBookingUrlForm = LocationFormFactory.createOnlineBookingUrlForm(this.fb, this.onlineBookingUrlDto);
  }

  close(): void {
    this.dialogRef.close();
  }

  manage(): void {
    if (this.onlineBookingUrlForm.invalid) {
      this.onlineBookingUrlForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.onlineBookingUrlForm.value);
  }
}
